(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-shop-parts-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brp-shop-drawer')) {
    class BrpShopDrawer extends HTMLElement {
      connectedCallback() {
        this.initializationFrame = requestAnimationFrame(() => this.initializeDrawer());
      }

      initializeDrawer() {
        if (!this.isConnected || this.initialized) return;
        this.dialog = this.querySelector('dialog');
        this.trigger = document.getElementById(this.dataset.triggerId);
        if (!this.dialog || !this.trigger) return;
        this.initialized = true;
        this.openDrawer = this.openDrawer.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleBreakpoint = this.handleBreakpoint.bind(this);
        this.trigger.addEventListener('click', this.openDrawer);
        this.dialog.addEventListener('click', this.handleClick);
        this.dialog.addEventListener('cancel', this.handleCancel);
        this.mobileBreakpoint = window.matchMedia('(max-width: 989px)');
        this.mobileBreakpoint.addEventListener('change', this.handleBreakpoint);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initializationFrame);
        clearTimeout(this.closeTimer);
        this.panelAnimation?.cancel();
        if (!this.initialized) return;
        this.trigger.removeEventListener('click', this.openDrawer);
        this.dialog.removeEventListener('click', this.handleClick);
        this.dialog.removeEventListener('cancel', this.handleCancel);
        this.mobileBreakpoint.removeEventListener('change', this.handleBreakpoint);
        if (this.dialog.open) this.dialog.close();
        document.documentElement.classList.remove('brp-shop-drawer-is-open');
        this.initialized = false;
      }

      openDrawer(event) {
        event.preventDefault();
        clearTimeout(this.closeTimer);
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.classList.add('brp-shop-drawer-is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => this.dialog.classList.add('brp-shop-drawer--visible'));
      }

      showCategory(button) {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel || !this.contains(panel)) return;
        this.hideCategory(false);
        this.activeCategory = button;
        this.activePanel = panel;
        panel.hidden = false;
        button.setAttribute('aria-expanded', 'true');
        this.dialog.classList.add('brp-shop-drawer--has-submenu');
        panel.querySelector('h2').focus({ preventScroll: true });
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.panelAnimation = panel.animate(
            [{ transform: 'translateX(-100%)' }, { transform: 'translateX(0)' }],
            { duration: 360, easing: 'cubic-bezier(.22, 1, .36, 1)' }
          );
        }
      }

      hideCategory(restoreFocus = true) {
        this.panelAnimation?.cancel();
        this.panelAnimation = null;
        if (this.activePanel) this.activePanel.hidden = true;
        if (this.activeCategory) {
          this.activeCategory.setAttribute('aria-expanded', 'false');
          if (restoreFocus) this.activeCategory.focus();
        }
        this.activePanel = null;
        this.activeCategory = null;
        this.dialog.classList.remove('brp-shop-drawer--has-submenu');
      }

      closeDrawer() {
        this.dialog.classList.remove('brp-shop-drawer--visible');
        this.trigger.setAttribute('aria-expanded', 'false');
        clearTimeout(this.closeTimer);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.finishClose();
        } else {
          this.closeTimer = window.setTimeout(() => this.finishClose(), 300);
        }
      }

      finishClose() {
        if (this.dialog.classList.contains('brp-shop-drawer--visible')) return;
        this.hideCategory(false);
        if (this.dialog.open) this.dialog.close();
        document.documentElement.classList.remove('brp-shop-drawer-is-open');
        if (this.trigger.isConnected) this.trigger.focus();
      }

      handleClick(event) {
        if (event.target === this.dialog) {
          this.closeDrawer();
          return;
        }
        const category = event.target.closest('[data-brp-category]');
        if (category) {
          if (category === this.activeCategory) this.hideCategory();
          else this.showCategory(category);
          return;
        }
      }

      handleCancel(event) {
        event.preventDefault();
        if (this.activePanel) this.hideCategory();
        else this.closeDrawer();
      }

      handleBreakpoint(event) {
        if (event.matches && this.dialog.open) this.closeDrawer();
      }
    }

    customElements.define('brp-shop-drawer', BrpShopDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
